<template lang="pug">
  vue-form
</template>

<script>

import FormSp from "@/components/tigo/Index"

// Constantes
const COMPONENT_NAME= "FormSpTigo"

export default {
  name: COMPONENT_NAME,
  components: {
    "vue-form": FormSp
  }
}
</script>
